import { gasPrice } from '@core/services/gasPrice';

export const getGasPrice = async (id: number) => {
	return await gasPrice.get(id);
};
